import { defineChain } from "viem";
import { boba, type Chain, mainnet, sei } from "viem/chains";

const form = defineChain({
  id: 478,
  name: "Form Network",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.form.network/http"],
      webSocket: ["wss://rpc.form.network/ws"],
    },
  },
  blockExplorers: {
    default: {
      name: "Form Network Explorer",
      url: "https://explorer.form.network/",
    },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
    },
  },
});

const swell = defineChain({
  id: 1923,
  name: "Swell Mainnet",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/swell"],
      webSocket: ["wss://rpc.ankr.com/swell/ws"],
    },
  },
  blockExplorers: {
    default: {
      name: "Swell Chain Explorer",
      url: "https://explorer.swellnetwork.io/",
    },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 32,
    },
  },
});

const rari = defineChain({
  id: 1380012617,
  name: "Rari Chain",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.rpc.rarichain.org/http"],
      webSocket: ["wss://mainnet.rpc.rarichain.org/ws"],
    },
  },
  blockExplorers: {
    default: {
      name: "Rari Explorer",
      url: "https://mainnet.explorer.rarichain.org",
    },
  },
  contracts: {
    multicall3: {
      address: "0x3F5Fc48153f8aDd3E429F0c84fA6FEd5c58657Dc",
    },
  },
});

const plume = defineChain({
  id: 98866,
  name: "Plume Mainnet",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://phoenix-rpc.plumenetwork.xyz"],
    },
  },
  blockExplorers: {
    default: {
      name: "Plume Mainnet Explorer",
      url: "https://phoenix-explorer.plumenetwork.xyz",
    },
  },
  contracts: {
    multicall3: {
      address: "0xF9DA0EF6635F6134D9d1B7eAE025159D26ce5838",
      blockCreated: 1,
    },
  },
});

export { boba, form, mainnet, plume, rari, sei, swell };
export type { Chain };
